/* eslint-disable no-irregular-whitespace */

import { Navbar, Footer } from './sections'

export default `
<html data-wf-page="6187c4ffefcbe929a240d78b" data-wf-site="617aeb5a738d7f6b279e7a99">

<head>
  <meta charset="utf-8">
  <link href="/landing/css/normalize.min.css" rel="stylesheet" type="text/css">
  <link href="/landing/css/webflow.min.css" rel="stylesheet" type="text/css">
  <link href="/landing/css/cnotes-landing.webflow.min.css" rel="stylesheet" type="text/css">
  <script src="https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js" type="text/javascript"></script>
  <script type="text/javascript">WebFont.load({ google: { families: ["Asap:regular,500,600,700"] } });</script>
  <!-- [if lt IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/html5shiv/3.7.3/html5shiv.min.js" type="text/javascript"></script><![endif] -->
  <script
    type="text/javascript">! function (o, c) { var n = c.documentElement, t = " w-mod-"; n.className += t + "js", ("ontouchstart" in o || o.DocumentTouch && c instanceof DocumentTouch) && (n.className += t + "touch") }(window, document);</script>
  <link href="/favicon.ico" rel="apple-touch-icon">
</head>

<body class="bg-neutral-800">
  <div style="opacity:0" class="page-wrapper">
    ${Navbar}
    <section class="section home-hero wf-section">
      <div class="container-medium-940px home-hero">
        <h1 data-w-id="abc7287a-ad94-a3ec-8716-36750d55fc4e"
          style="-webkit-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
          class="display-1 home-hero">More sponsorships.</h1>
        <h1 data-w-id="d8d84c69-2595-3665-9ae1-0f709f516d9e"
          style="-webkit-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
          class="display-1">Faster.</h1>
        <p data-w-id="749e645b-3b65-110f-471d-f6af6dfbc601"
          style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
          class="paragraph-large home-hero">Create a free profile and let brands
          approach you with sponsorship opportunities.<strong><br></strong></p>
        <div data-w-id="b1ff49e2-6272-bd33-f83d-82e4206a6d65"
          style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
          class="_2-buttons-wrapper">
          <div class="button-primary-gradient _2-buttons">
            <a href="/signup/creator" class="button-primary w-button">Apply now</a>
          </div>
        </div>
      </div>
      <div class="container-default home-hero w-container">
        <div data-w-id="1535d204-b8f5-78ad-1998-57322399a3bd"
          style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
          class="home-hero-images-wrapper"><img src="https://d2vh08r8g1sliz.cloudfront.net/landing/Creator-Profile.png"
            loading="lazy"
            sizes="(max-width: 479px) 84vw, (max-width: 767px) 82vw, (max-width: 1919px) 84vw, 1054.234375px"
            srcset="https://d2vh08r8g1sliz.cloudfront.net/landing/Creator-Profile-p-500.png 500w, https://d2vh08r8g1sliz.cloudfront.net/landing/Creator-Profile-p-800.png 800w, https://d2vh08r8g1sliz.cloudfront.net/landing/Creator-Profile.png 1080w"
            alt="hero" class="image home-hero-1" /></div>
        <div data-w-id="a052a4bf-34f8-d790-1f5c-e2592094cb97" class="bg-gradient-blur-wrapper home-hero-1"></div>
        <div class="bg-gradient-blur-wrapper home-hero-2"></div>
      </div>
    </section>
    <section class="section home-features reduction wf-section">
      <div class="container-medium-756px home-features">
        <h2 class="heading-3">Better sponsorships</h2>
        <p class="paragraph home-features">No negotiations, no delays - just a streamlined way to work with keyboard
          brands that your audience will love. All it takes is a few clicks to create a sponsorship listing.</p>
      </div>
      <div class="container-default home-features w-container">
        <div data-w-id="732ee068-9ebc-442b-d4e2-f4da443a3826" style="opacity:0" class="w-layout-grid values-grid">
          <div class="card value"><img
              src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-1-values-dark-template.svg" loading="lazy"
              alt="Featuring you" class="image card-value-icon" />
            <div class="card-value-content">
              <h3 class="title card-value">The spotlight&#x27;s on you</h3>
              <p class="paragraph card-value">Make an elegantly designed profile containing the exact information that
                brands are looking for.</p>
            </div>
          </div>
          <div class="card value"><img
              src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-5-features-dark-template_1.svg" loading="lazy"
              alt="Relax" class="image card-value-icon" />
            <div class="card-value-content">
              <h3 class="title card-value">Brands apply to you</h3>
              <p class="paragraph card-value">No negotiations, no delays. Sit back and let brands send you offers on
                your terms.</p>
            </div>
          </div>
          <div class="card value"><img src="https://d2vh08r8g1sliz.cloudfront.net/landing/Frame-37148.svg"
              loading="lazy" alt="Compare prices" class="image card-value-icon" />
            <div class="card-value-content">
              <h3 class="title card-value">Transparent offers</h3>
              <p class="paragraph card-value">Compare offers side by side with specification and pricing details
                upfront.</p>
            </div>
          </div>
          <div class="card value"><img
              src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-4-values-dark-template.svg" loading="lazy"
              alt="Values" class="image card-value-icon" />
            <div class="card-value-content">
              <h3 class="title card-value">No commitment</h3>
              <p class="paragraph card-value">100% free and confidential. Choose which offers to select, completely
                risk-free.</p>
            </div>
          </div>
        </div>
        <div class="flex-vc home-features">
          <div class="_2-buttons-wrapper">
            <div class="button-primary-gradient _2-buttons">
              <a href="/signup/creator" class="button-primary w-button">Apply to join</a>
            </div>
          </div>
        </div>
        <div class="bg-gradient-blur-wrapper big">
          <div class="bg-gradient-blur-circle-3 pink big"></div>
          <div class="bg-gradient-blur-circle-2 blue-2"></div>
          <div class="bg-gradient-blur-circle-1 purple-2 big"></div>
        </div>
      </div>
    </section>
    <section class="section cta wf-section"></section>
    <section class="section home-steps wf-section">
      <div class="container-default w-container">
        <div class="home-steps-wrapper">
          <div class="split-content home-steps-left">
            <h2 class="heading-4">How does it work?</h2>
            <p class="paragraph home-steps">We designed the entire experience to help you do sponsorships faster and
              with more confidence.</p>
            <div class="button-primary-gradient">
              <a href="/signup/creator" class="button-primary w-button">Join for free</a>
            </div>
          </div>
          <div class="split-content home-steps-right">
            <div class="w-layout-grid home-steps-grid">
              <div data-w-id="5ca80c16-ab7b-99c2-0c1a-a77b0e738a53"
                style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
                class="card home-step">
                <div class="card-home-step-content">
                  <div class="title h3-size card-home-step-number">1</div>
                  <h3 class="title card-home-step">List your sponsorships</h3>
                  <p class="paragraph card-home-step">List your available sponsorship formats for a set time period.
                    Brands can then discover and make offers to you.</p>
                </div>
                <div class="image-wrapper card-home-step"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/list-offers.png" loading="lazy" alt="List offers"
                    class="image card-home-step" /></div>
              </div>
              <div data-w-id="66be55b7-13bf-9864-46c3-3b493748a167"
                style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
                class="card home-step">
                <div class="card-home-step-content">
                  <div class="title h3-size card-home-step-number">2</div>
                  <h3 class="title card-home-step">Receive offers</h3>
                  <p class="paragraph card-home-step">Sit back and wait while brands submit offers to you. Have the
                    market decide your sponsorship price through a transparent offer process.</p>
                </div>
                <div class="image-wrapper card-home-step"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/receive-offers.png" loading="lazy"
                    alt="Receive offers" class="image card-home-step" /></div>
              </div>
              <div data-w-id="b004a6e0-c506-f383-4ef2-7ba62c69ed92"
                style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
                class="card home-step">
                <div class="card-home-step-content">
                  <div class="title h3-size card-home-step-number">3</div>
                  <h3 class="title card-home-step">Select brands</h3>
                  <p class="paragraph card-home-step">Compare offers side by side and select the brands you&#x27;d like
                    to work with.</p>
                </div>
                <div class="image-wrapper card-home-step"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/select-offers.png" loading="lazy"
                    alt="Select brands" class="image card-home-step" /></div>
              </div>
              <div data-w-id="6ab9030c-f822-6a18-b144-9efcc7a7389b"
                style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
                class="card home-step">
                <div class="card-home-step-content">
                  <div class="title h3-size card-home-step-number">4</div>
                  <h3 class="title card-home-step">Submit video</h3>
                  <p class="paragraph card-home-step">Submit the video URL for brand approval.<span
                      class="text-no-wrap"></span></p>
                </div>
                <div class="image-wrapper card-home-step"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/submit-video.png" loading="lazy"
                    alt="Submit video" class="image card-home-step" /></div>
              </div>
              <div data-w-id="75ac40fd-fea7-3586-f026-0097732d5527"
                style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
                class="card home-step">
                <div class="card-home-step-content">
                  <div class="title h3-size card-home-step-number">5</div>
                  <h3 class="title card-home-step">Complete deal</h3>
                  <p class="paragraph card-home-step">Confirm that you have received payment from the brand to complete
                    the deal. <span class="text-no-wrap"></span></p>
                </div>
                <div class="image-wrapper card-home-step"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/wait-for-payment.png" loading="lazy"
                    alt="Complete deal" class="image card-home-step" /></div>
              </div>
            </div>
            <div class="bg-gradient-blur-wrapper home-steps">
              <div class="bg-gradient-blur-circle-3 pink"></div>
              <div class="bg-gradient-blur-circle-2 blue"></div>
              <div class="bg-gradient-blur-circle-1 purple"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section cta-last wf-section">
      <div class="container-default w-container">
        <div class="cta-card-wrapper">
          <div data-w-id="8848cb72-b24b-fd5b-4a1b-312ad063e45c" class="card cta">
            <h2 class="title card-cta">Access exclusive sponsorships</h2>
            <div class="_2-buttons-wrapper">
              <a href="/signup/creator" class="button-primary button-white _2-buttons w-button">Apply now</a>
            </div>
          </div>
          <div data-w-id="8848cb72-b24b-fd5b-4a1b-312ad063e464" class="cta-gradient-blur"></div>
        </div>
      </div>
    </section>
    ${Footer}
  </div>
  <script src="https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=617aeb5a738d7f6b279e7a99"
    type="text/javascript" integrity="sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0=" crossorigin="anonymous">
    </script>
  <script src="/landing/js/webflow.min.js" type="text/javascript"></script>
  <!-- [if lte IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/placeholders/3.0.2/placeholders.min.js"></script><![endif] -->
</body>

</html>
`
